import makeSlice from '@web/slices/banner/sliceMaker'

import {initOrderSheetByAPI} from '../../actions/familyPay'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
            const {
                data: {products},
            } = payload

            state.naverBenefit = products.some(({naverBenefit}) => naverBenefit)
        })
    },
})

export default slice.reducer
